import React from 'react';
import { CountdownBar } from './components/CountdownBar';
import { OfferUrgency } from './components/OfferUrgency';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { ProblemSection } from './components/ProblemSection';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { BenefitsSection } from './components/BenefitsSection';
import { Testimonials } from './components/Testimonials';
import { OfferSection } from './components/OfferSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-pastel-white font-body text-gray-800 overflow-x-hidden" data-id="element-0">
      <CountdownBar data-id="element-1" />
      <Hero data-id="element-2" />
      <SocialProof data-id="element-3" />
      <ProblemSection data-id="element-4" />
      <TomosSection data-id="element-5" />
      <BonusSection data-id="element-6" />
      <BenefitsSection data-id="element-7" />
      <Testimonials data-id="element-8" />
      <OfferUrgency data-id="element-9" />
      <OfferSection data-id="element-10" />
      <FaqSection data-id="element-11" />
      <FinalCta data-id="element-12" />
      <Footer data-id="element-13" />
    </div>;
}